export default __webpack_public_path__ + "static/media/shoppinglist_card_1@3x.0407754d.png";